
import { useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Card, CardGroup } from 'react-bootstrap';
import './DungeonGenerationInfoPanel.css';
/*const options = [
  {
    name: 'Enable backdrop (default)',
    scroll: false,
    backdrop: true,
  },
  {
    name: 'Disable backdrop',
    scroll: false,
    backdrop: false,
  },
  {
    name: 'Enable body scrolling',
    scroll: true,
    backdrop: false,
  },
  {
    name: 'Enable both scrolling & backdrop',
    scroll: true,
    backdrop: true,
  },
];*/

function LockwoodPublishingInfoPanel({ name, ...props }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const toggleShow = () => setShow((s) => !s);
  //https://react-bootstrap.github.io/components/cards/
  return (
    <>
      <button className='astext' onClick={toggleShow}><u>Read More</u></button>
      <Offcanvas show={show} onHide={handleClose} {...props}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title><h1>XR Games</h1></Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ContentBlock>
          </ContentBlock>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default LockwoodPublishingInfoPanel;

function ContentBlock() {
  return (
    <>
      <Card>
        <Card.Header ><h5>Overview </h5>
          <a href="https://www.xrgames.io/" target="_blank">Visit their website</a>
        </Card.Header>

        <Card.Body>
          <Card>
            <Card.Body>
              <Card.Text>
                <h2>Key Tech</h2>
                <ul>
                  <li>Unity</li>
                  <li>C#</li>
                  <li>PSVR2</li>
                  <li>Oculus</li>
                  <li>Open XR</li>
                  <li>Devops</li>
                </ul>

                <h2>Role</h2>
                <p>Coming Soon once announcement of the project</p>
              </Card.Text>
            </Card.Body>
          </Card>
        </Card.Body>
      </Card>
    </>
  );
}